import * as React from "react";
import { cn } from "cn";
import { Switch as SwitchPrimitive } from "radix-ui";

export interface SwitchProps {
  checked?: boolean;
  onChange?: (next: boolean) => void;
  tone?: "brand" | "person" | "company" | "event" | "opportunity";
  size?: "sm" | "md";
  disabled?: boolean;
  ariaLabel?: string;
  style?: React.CSSProperties;
  className?: string;
}
const tones = {
  brand: "data-[state=checked]:bg-primary", person: "data-[state=checked]:bg-[var(--entity-person)]",
  company: "data-[state=checked]:bg-[var(--entity-company)]", event: "data-[state=checked]:bg-[var(--entity-event)]",
  opportunity: "data-[state=checked]:bg-[var(--entity-opportunity)]",
};
function Switch({checked = false, onChange, tone = "brand", size = "md", disabled = false, ariaLabel, style, className}: SwitchProps) {
  return <SwitchPrimitive.Root data-slot="switch" data-size={size} checked={checked} {...(onChange ? {onCheckedChange: onChange} : {})}
    disabled={disabled} aria-label={ariaLabel} style={style}
    className={cn("group/switch inline-flex shrink-0 items-center rounded-full border-0 p-[3px] outline-none transition-colors focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50 data-[state=unchecked]:bg-[var(--warm-300)]",
      size === "sm" ? "h-5 w-[34px]" : "h-6 w-[42px]", tones[tone], className)}>
    <SwitchPrimitive.Thumb data-slot="switch-thumb" className={cn(
      "pointer-events-none block rounded-full bg-card shadow-sm transition-transform data-[state=unchecked]:translate-x-0",
      size === "sm" ? "size-3.5 data-[state=checked]:translate-x-[14px]" : "size-[18px] data-[state=checked]:translate-x-[18px]"
    )} />
  </SwitchPrimitive.Root>;
}
export { Switch };
